import { forwardRef, type PropsWithChildren } from "react";

import { cn } from "$/lib/utils/functions/misc.functions";

import type { CarouselSlideProps } from "./CarouselSlide.types";

// in rem
const SLIDE_SPACING = 1;
// in %
const SLIDE_SIZE = 100;

const CarouselSlide = forwardRef<
  HTMLDivElement,
  PropsWithChildren<CarouselSlideProps>
>(({ carouselType, selected, children }, forwardedRef) => {
  return (
    <div
      ref={forwardedRef}
      className={cn(
        `min-w-0 pl-[${SLIDE_SPACING}rem] ml-2 h-full translate-x-3d`,
      )}
      style={{
        flex: `0 0 ${carouselType !== "view-4" ? SLIDE_SIZE : selected ? 50 : 25}%`,
      }}
    >
      <div
        className={cn(`flex h-full select-none items-center justify-center`)}
      >
        {children}
      </div>
    </div>
  );
});

CarouselSlide.displayName = "CarouselSlide";

export default CarouselSlide;
